import { LicensesRepository, ActivationCodesRepository, AppIntegrationsRepository, AppPricesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';
import offersConfiguration from '../../../../scripts/abtesting/data';


const _directiveDependencies = [];
const _controllerDependencies = [
    '$scope', '$state', '$window', 'Util', '$rootScope', 'FlexiblePromotionsRestService',
];

class StoreComparisonController {

    constructor($scope, $state, $window, Util, $rootScope) {

        const activationCodesRepo = ActivationCodesRepository.getAll();
        const licensesRepo = LicensesRepository.getAll();
        const userHasSubscriptions =
            activationCodesRepo.length > 0 || licensesRepo.length > 0;

        $scope.comparisonBundles = CWCONFIG.store.bundles;
        $scope.productsConfig = CWCONFIG.store.productsConfig;
        $scope.products = CWCONFIG.store.products;

        $scope.language = CWCONFIG.language;
        $scope.brandName = CWCONFIG.partnerConfig.name;

        // if ($rootScope.cmaGBapplies) {

        //     $scope.isFromUK = true;
        //     $scope.ukBuyUrl = 'https://www.avira.com/en/campaigns/crm/q2-fy23/f2p-antivirus-pro-mya?cookiebot_off=true';

        // }

        const languagesAwards = CWCONFIG.partnerConfig.translationsLinks.awards.languages;

        if (languagesAwards.find(element => element === CWCONFIG.language)) {

            $scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', CWCONFIG.language);

        } else {

            $scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', 'en');

        }

        Mixpanel.send('ConnectWeb Store Open', {
            Source: 'Direct',
            Store: 'cwStore',
        });

        // Check existing offers for discounts
        $scope.offers = {};
        offersConfiguration.forEach((offer) => {

            $scope.offers[offer.productId] = offer;
            $scope.storeHasOffers = true;

        });

        $scope.appIds = {};

        const groupData = (arr, key) => {

            if (!Util.deepFind($scope.appIds, key)) {

                $scope.appIds[key] = [];

            }

            arr.forEach((app) => {

                const runtime = Util.deepFind($scope.productsConfig[app], 'runtime') || 12;
                const users = Util.deepFind($scope.productsConfig[app], 'users') || 1;
                $scope.appIds[key].push(`${app}_${runtime}_${users}`);

            });

        };

        groupData($scope.comparisonBundles, 'bundles');
        groupData($scope.products, 'products');

        // Get the prices for each product

        $scope.bundleComparisonFeatures = {};

        // Create the comparison features object for each bundle
        const comparisonFeatures = {};
        $scope.comparisonBundles.forEach((bundle) => {

            const bundleData = AppIntegrationsRepository.getById(bundle);
            $scope.bundleComparisonFeatures[bundle] = {};
            const features = Util.deepFind(bundleData, 'attributes.resource.comparisonFeatures') || [];

            features.forEach((feature) => {

                comparisonFeatures[feature] = true;
                $scope.bundleComparisonFeatures[bundle][feature] = true;

            });

        });

        // remove isec0 feature_fix_software
        $scope.bundleComparisonFeatures.isec0.comparison_feature_fix_software = false;

        // Get product data from product catalog
        $scope.productData = {};
        $scope.comparisonBundles
            .concat($scope.products)
            .forEach((product) => {

                const productData = AppIntegrationsRepository.getById(product);
                const runtime = Util.deepFind($scope.productsConfig[product], 'runtime') || 12;
                const users = Util.deepFind($scope.productsConfig[product], 'users') || 1;
                $scope.productData[product] = productData;
                $scope.productData[product].productConfig = `${product}_${runtime}_${users}`;
                $scope.productData[product].users = users;

            });


        $scope.comparisonFeatures = Object.keys(comparisonFeatures);

        //* Promotional Campaign
        //* To be commented when the campaign is over
        // $rootScope.createCMAlabels('aapd5_12_1', 'Antivirus Pro',
        // 'aapd5', '2023-06-08', '2023-06-30');
        // if (!$rootScope.cmaGBapplies) {

        //     $rootScope.createCMAlabels(
        //         'aps10_12_1',
        //         'Avira Prime',
        //         'aps10',
        //         '2023-11-23',
        //         '2023-12-03',
        //     );

        // }

        // $rootScope.createCMAlabels('aapd5_12_1', 'Antivirus Pro',
        // 'aapd5', '2023-06-08', '2023-06-30');

        // if ($rootScope.showAIACardInFreeStore) {

        //     $rootScope.createCMAlabels('adwp1_12_1', 'Identity Assistant',
        // 'adwp1', '2023-06-14', '2023-06-31');

        // }

        $scope.$on('$destroy', () => {

            $rootScope.welcomeOffers = {};

        });

        $scope.buy = (appId) => {

            const runtime = Util.deepFind($scope.productsConfig[appId], 'runtime') || 12;
            const currentPrice = AppPricesRepository.getSinglePrice(appId, runtime, '1');

            let price = '';
            let discount = '';

            if (currentPrice) {

                if (Util.deepFind(currentPrice, 'attributes.promotion')) {

                    price = Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                    discount = Util.deepFind(currentPrice, 'attributes.promotion.discount');

                } else {

                    price = Util.deepFind(currentPrice, 'attributes.price_string');
                    discount = 0;

                }

            }

            Mixpanel.send('ConnectWeb Store Buy Click', {
                'Product ID': appId,
                Page: 'Comparison Store Page',
                Runtimes: runtime.toString(),
                Price: price,
                Discount: discount,
            });

            // if (appId === 'aapd5' && $scope.isFromUK) {

            //     $window.open($scope.ukBuyUrl, '_blank');
            //     return;

            // }

            // Remove the aapd5 promotion for free users < 120 days
            // const user = MeRepository.getMyUser();
            // const userRegistrationDate = Util.deepFind(user, 'attributes.date_registered');
            // const today = moment();
            // const registrtionDate = moment(userRegistrationDate);
            // const accountDays =
            //     parseInt(moment.duration(today.diff(registrtionDate)).asDays(), 10) + 1;
            // const campaignBreakpoint = Util.deepFind(CWCONFIG,
            // 'features.offerBanner.campaignBannerDaysBreakpoint') || 120;

            const subsource = 'store';
            // if (licensesRepo.length === 0 && appId === 'aapd5') {

            //     subsource = 'renew';

            // }

            $state.go('root.dashboard.store.ltb.buy', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource,
                promotion: true,
            }, {
                reload: false,
            });

        };

        $scope.openMarketingCard = (appId) => {

            Mixpanel.send('ConnectWeb Learn More Click', {
                Page: 'Store',
                Product: $scope.productData[appId].attributes.resource.oeName,
                'Product ID': appId,
            });

            $state.go('root.dashboard.store.ltb', {
                ltb: 'buy',
                resourceId: appId,
            });

        };

        /**
         * When the user hovers on header or sidebar, Trial modal will be shown.
         * Criterias to show the trial modal:
         * - the user is free
         * - modal is configured in the config file
         * - the modal has not been seen by the user before (check local storage)
         * - $scope.enableTrialModal is 'true'
         * - do not show modal for users on mobile
         *
         * Know problem: when the user navigates to the store page from the sidebar,
         * after clicking
         * on the store page button, the mouseover event set in the sidebar is
         * fired multiple time
         * as long as the user moves the mouse over the sidebar.
         * So in order to prevent the modal
         * firing when the user just entered the page, we set '$scope.enableTrialModal' to true
         * when the user enters with the mouse over the store page content
         */
        $scope.enableTrialModal = false;
        const openTrialModal = () => {

            // detect device navigator OS
            const currentNavigatorOs = Util.getDeviceNavigator();

            // open trial modal
            if (!userHasSubscriptions &&
                Util.deepFind(CWCONFIG, 'features.trialModal') &&
                CWCONFIG.features.trialModal.showOffer &&
                $scope.enableTrialModal &&
                !localStorage.getItem(CWCONFIG.features.trialModal.localStorageName) &&
                currentNavigatorOs !== 'android' && currentNavigatorOs !== 'ios'
            ) {

                $scope.enableTrialModal = false;

                Mixpanel.send('ConnectWeb Trial Modal open', {
                    Page: 'Store',
                    'Product ID': Util.deepFind(CWCONFIG, 'features.trialModal.appId'),
                });

                localStorage.setItem(Util.deepFind(CWCONFIG, 'features.trialModal.localStorageName'), true);

                $state.go('root.dashboard.store.ltb', {
                    ltb: 'trial',
                    resourceId: Util.deepFind(CWCONFIG, 'features.trialModal.appId') || [],
                });

            }

        };

        eventManager.subscribe('mainControlls:hover', openTrialModal);

    }

}

class StoreComparisonDirective {

    constructor() {

        this.template = require('./store-comparison.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $scope, $state, $window,
            Util, AppPricesRestService, ErrorHandler,
        ) =>
            new StoreComparisonController(
                $scope, $state, $window, Util,
                AppPricesRestService, ErrorHandler,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'StoreComparistonCtrl';

    }

}

_directiveDependencies.push(() => new StoreComparisonDirective());


angular.module('directives')
    .directive('storeComparison', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/store-comparison/store-comparison.js